<template>
  <div>
    <!-- 编辑组件的内容会通过props传入并在父组件中展示 -->
  </div>
</template>

<script setup>
import { ElMessageBox } from 'element-plus';
import { isBetaHistoryModel, normalizeBetaHistoryDuration } from '@/utils/betaHistoryDuration';

const formatDuration = value => normalizeBetaHistoryDuration(value) || value || '-';

// 显示超主点订单详情
const showRegularOrderDetails = (row) => {
  // 将所有属性格式化为易读的表格
  let content = '<div class="order-details">';
  content += '<h3>订单基本信息</h3>';
  content += '<table class="details-table">';
  content += `<tr><td>订单类型</td><td>${row.orderType || '-'}</td></tr>`;
  content += `<tr><td>订单日期</td><td>${row.orderDate || '-'}</td></tr>`;
  content += `<tr><td>患者姓名</td><td>${row.patientName || '-'}</td></tr>`;
  content += `<tr><td>验光师</td><td>${row.optometrist || '-'}</td></tr>`;
  content += `<tr><td>地区</td><td>${row.region || '-'}</td></tr>`;
  content += `<tr><td>订单型号</td><td>${row.lensModel || '-'}</td></tr>`;
  if (isBetaHistoryModel(row.lensModel)) {
    content += `<tr><td>是否使用阿托品滴眼液</td><td>${row.atropineEyeDropsUsed || '-'}</td></tr>`;
    content += `<tr><td>阿托品滴眼液停药时长</td><td>${formatDuration(row.atropineEyeDropsStopDuration)}</td></tr>`;
    content += `<tr><td>是否配戴过角膜塑形镜（OK镜）</td><td>${row.orthokeratologyLensUsed || '-'}</td></tr>`;
    content += `<tr><td>角膜塑形镜（OK镜）停戴时长</td><td>${formatDuration(row.orthokeratologyLensStopDuration)}</td></tr>`;
  }
  content += `<tr><td>验配单位</td><td>${row.company || '-'}</td></tr>`;
  content += `<tr><td>采购单位</td><td>${row.purchasingUnits || '-'}</td></tr>`;
  content += `<tr><td>创建时间</td><td>${row.createdAt || '-'}</td></tr>`;
  content += `<tr><td>更新时间</td><td>${row.updatedAt || '-'}</td></tr>`;
  content += '</table>';

  // 常规验光数据
  content += '<h3>常规验光</h3>';
  content += '<table class="details-table">';
  content += '<tr><th>参数</th><th>右眼</th><th>左眼</th></tr>';
  content += `<tr><td>球镜</td><td>${row.regularOdSphere > 0 ? '+' + row.regularOdSphere : row.regularOdSphere || '-'}</td>
            <td>${row.regularOsSphere > 0 ? '+' + row.regularOsSphere : row.regularOsSphere || '-'}</td></tr>`;
  content += `<tr><td>柱镜</td><td>${row.regularOdCylinder || '-'}</td><td>${row.regularOsCylinder || '-'}</td></tr>`;
  content += `<tr><td>轴位</td><td>${row.regularOdAxis || '-'}</td><td>${row.regularOsAxis || '-'}</td></tr>`;
  content += `<tr><td>视力</td><td>${row.regularOdVision || '-'}</td><td>${row.regularOsVision || '-'}</td></tr>`;
  content += `<tr><td>立体视功能</td><td colspan="2">${row.regularStereoscopicVisionFunction || '-'}</td></tr>`;
  content += `<tr><td>双眼视力</td><td colspan="2">${row.regularBinocularVision || '-'}</td></tr>`;
  content += `<tr><td>双眼视力</td><td colspan="2">${row.regularBinocularVision || '-'}</td></tr>`;
  content += '</table>';

  // 散瞳验光数据
  content += `<h3>散瞳验光</h3>`;
  content += '<table class="details-table">';
  content += '<tr><th>参数</th><th>右眼</th><th>左眼</th></tr>';
  content += `<tr><td>球镜</td><td>${row.cycloplegicOdSphere > 0 ? '+' + row.cycloplegicOdSphere : row.cycloplegicOdSphere || '-'}</td><td>${row.cycloplegicOsSphere > 0 ? '+' + row.cycloplegicOsSphere : row.cycloplegicOsSphere || '-'}</td></tr>`;
  content += `<tr><td>柱镜</td><td>${row.cycloplegicOdCylinder || '-'}</td><td>${row.cycloplegicOsCylinder || '-'}</td></tr>`;
  content += `<tr><td>轴位</td><td>${row.cycloplegicOdAxis || '-'}</td><td>${row.cycloplegicOsAxis || '-'}</td></tr>`;
  content += `<tr><td>视力</td><td>${row.cycloplegicOdVision || '-'}</td><td>${row.cycloplegicOsVision || '-'}</td></tr>`;
  content += '</table>';

  // 超主点验光数据
  content += `<h3>超主点验光</h3>`;
  content += '<table class="details-table">';
  content += '<tr><th>参数</th><th>右眼</th><th>左眼</th></tr>';
  content += `<tr><td>球镜</td><td>${row.superOdSphere > 0 ? '+' + row.superOdSphere : row.superOdSphere || '-'}</td>
            <td>${row.superOsSphere > 0 ? '+' + row.superOsSphere : row.superOsSphere || '-'}</td></tr>`;
  content += `<tr><td>柱镜</td><td>${row.superOdCylinder || '-'}</td><td>${row.superOsCylinder || '-'}</td></tr>`;
  content += `<tr><td>轴位</td><td>${row.superOdAxis || '-'}</td><td>${row.superOsAxis || '-'}</td></tr>`;
  content += `<tr><td>视力</td><td>${row.superOdVision || '-'}</td><td>${row.superOsVision || '-'}</td></tr>`;
  content += `<tr><td>数量</td><td>${row.odQuantity || '-'}</td><td>${row.osQuantity || '-'}</td></tr>`;
  content += `<tr><td>立体视功能</td><td colspan="2">${row.superStereoscopicVisionFunction || '-'}</td></tr>`;
  content += `<tr><td>双眼视力</td><td colspan="2">${row.superBinocularVision || '-'}</td></tr>`;
  content += `<tr><td>双眼视力</td><td colspan="2">${row.superBinocularVision || '-'}</td></tr>`;
  content += '</table>';

  // 角膜曲率
  content += '<h3>角膜曲率</h3>';
  content += '<table class="details-table">';
  content += '<tr><th>参数</th><th>右眼</th><th>左眼</th></tr>';
  content += `<tr><td>K1</td><td>${row.odK1 || '-'}</td><td>${row.osK1 || '-'}</td></tr>`;
  content += `<tr><td>K2</td><td>${row.odK2 || '-'}</td><td>${row.osK2 || '-'}</td></tr>`;
  content += `<tr><td>眼轴</td><td>${row.odAxialLength || '-'}</td><td>${row.osAxialLength || '-'}</td></tr>`;
  content += `<tr><td>脉络膜厚度</td><td>${row.odChoroidalThickness || '-'}</td><td>${row.osChoroidalThickness || '-'}</td></tr>`;
  content += '</table>';

  // 眼镜参数
  content += '<h3>眼镜参数</h3>';
  content += '<table class="details-table">';
  content += '<tr><th>参数</th><th>右眼</th><th>左眼</th></tr>';
  content += `<tr><td>瞳高</td><td>${row.odPupilHeight || '-'}</td><td>${row.osPupilHeight || '-'}</td></tr>`;
  content += `<tr><td>瞳距</td><td>${row.odPupilDistance || '-'}</td><td>${row.osPupilDistance || '-'}</td></tr>`;
  content += `<tr><td>双眼瞳距</td><td colspan="2">${row.binocularPupilDistance || '-'}</td></tr>`;
  content += `<tr><td>镜框编号</td><td colspan="2">${row.frameNumber || '-'}</td></tr>`;
  content += `<tr><td>镜框类型</td><td colspan="2">${row.frameType || '-'}</td></tr>`;
  content += '</table>';


  // 邮寄信息
  content += '<h3>邮寄信息</h3>';
  content += '<table class="details-table">';
  content += `<tr><td>收件人</td><td>${row.addressee || '-'}</td></tr>`;
  content += `<tr><td>联系电话</td><td>${row.phone || '-'}</td></tr>`;
  content += `<tr><td>物流编号</td><td>${row.trackingNumber || '-'}</td></tr>`;
  content += `<tr><td>邮寄日期</td><td>${row.deliveryDate || '-'}</td></tr>`;
  content += `<tr><td>邮寄地址</td><td>${row.shippingAddress || '-'}</td></tr>`;
  content += `<tr><td>备注</td><td>${row.remarks || '-'}</td></tr>`;
  content += '</table>';

  content += '</div>';

  // 添加详情样式
  addDetailStyle(content);
};

// 显示赋像散订单详情
const showFuxiangsanOrderDetails = (row) => {
  let content = '<div class="order-details">';
  content += '<h3>订单基本信息</h3>';
  content += '<table class="details-table">';
  content += `<tr><td>订单类型</td><td>${row.orderType || '-'}</td></tr>`;
  content += `<tr><td>订单日期</td><td>${row.orderDate || '-'}</td></tr>`;
  content += `<tr><td>患者姓名</td><td>${row.patientName || '-'}</td></tr>`;
  content += `<tr><td>验光师</td><td>${row.optometrist || '-'}</td></tr>`;
  content += `<tr><td>地区</td><td>${row.region || '-'}</td></tr>`;
  content += `<tr><td>订单型号</td><td>${row.lensModel || '-'}</td></tr>`;
  content += `<tr><td>验配单位</td><td>${row.company || '-'}</td></tr>`;
  content += `<tr><td>采购单位</td><td>${row.purchasingUnits || '-'}</td></tr>`;
  content += `<tr><td>创建时间</td><td>${row.createdAt || '-'}</td></tr>`;
  content += `<tr><td>更新时间</td><td>${row.updatedAt || '-'}</td></tr>`;
  content += '</table>';

  // 常规验光数据
  content += '<h3>常规验光</h3>';
  content += '<table class="details-table">';
  content += '<tr><th>参数</th><th>右眼</th><th>左眼</th></tr>';
  content += `<tr><td>球镜</td><td>${row.regularOdSphere > 0 ? '+' + row.regularOdSphere : row.regularOdSphere || '-'}</td>
            <td>${row.regularOsSphere > 0 ? '+' + row.regularOsSphere : row.regularOsSphere || '-'}</td></tr>`;
  content += `<tr><td>柱镜</td><td>${row.regularOdCylinder || '-'}</td><td>${row.regularOsCylinder || '-'}</td></tr>`;
  content += `<tr><td>轴位</td><td>${row.regularOdAxis || '-'}</td><td>${row.regularOsAxis || '-'}</td></tr>`;
  content += `<tr><td>视力</td><td>${row.regularOdVision || '-'}</td><td>${row.regularOsVision || '-'}</td></tr>`;
  content += `<tr><td>数量</td><td>${row.odQuantity || '-'}</td><td>${row.osQuantity || '-'}</td></tr>`;
  content += `<tr><td>双眼视力</td><td colspan="2">${row.regularBinocularVision || '-'}</td></tr>`;
  content += '</table>';

  // 散瞳验光数据
  content += `<h3>散瞳验光</h3>`;
  content += '<table class="details-table">';
  content += '<tr><th>参数</th><th>右眼</th><th>左眼</th></tr>';
  content += `<tr><td>球镜</td><td>${row.cycloplegicOdSphere > 0 ? '+' + row.cycloplegicOdSphere : row.cycloplegicOdSphere || '-'}</td><td>${row.cycloplegicOsSphere > 0 ? '+' + row.cycloplegicOsSphere : row.cycloplegicOsSphere || '-'}</td></tr>`;
  content += `<tr><td>柱镜</td><td>${row.cycloplegicOdCylinder || '-'}</td><td>${row.cycloplegicOsCylinder || '-'}</td></tr>`;
  content += `<tr><td>轴位</td><td>${row.cycloplegicOdAxis || '-'}</td><td>${row.cycloplegicOsAxis || '-'}</td></tr>`;
  content += `<tr><td>视力</td><td>${row.cycloplegicOdVision || '-'}</td><td>${row.cycloplegicOsVision || '-'}</td></tr>`;
  content += '</table>';

  // 试戴片验光数据
  content += `<h3>试戴片验光</h3>`;
  content += '<table class="details-table">';
  content += '<tr><th>参数</th><th>右眼</th><th>左眼</th></tr>';
  content += `<tr><td>球镜</td><td>${row.superOdSphere > 0 ? '+' + row.superOdSphere : row.superOdSphere || '-'}</td>
            <td>${row.superOsSphere > 0 ? '+' + row.superOsSphere : row.superOsSphere || '-'}</td></tr>`;
  content += `<tr><td>柱镜</td><td>${row.superOdCylinder || '-'}</td><td>${row.superOsCylinder || '-'}</td></tr>`;
  content += `<tr><td>轴位</td><td>${row.superOdAxis || '-'}</td><td>${row.superOsAxis || '-'}</td></tr>`;
  content += `<tr><td>视力</td><td>${row.superOdVision || '-'}</td><td>${row.superOsVision || '-'}</td></tr>`;
  content += `<tr><td>双眼视力</td><td colspan="2">${row.superBinocularVision || '-'}</td></tr>`;
  content += '</table>';

  // 角膜曲率
  content += '<h3>角膜曲率</h3>';
  content += '<table class="details-table">';
  content += '<tr><th>参数</th><th>右眼</th><th>左眼</th></tr>';
  content += `<tr><td>K1</td><td>${row.odK1 || '-'}</td><td>${row.osK1 || '-'}</td></tr>`;
  content += `<tr><td>K2</td><td>${row.odK2 || '-'}</td><td>${row.osK2 || '-'}</td></tr>`;
  content += `<tr><td>眼轴</td><td>${row.odAxialLength || '-'}</td><td>${row.osAxialLength || '-'}</td></tr>`;
  content += '</table>';

  // 眼镜参数
  content += '<h3>眼镜参数</h3>';
  content += '<table class="details-table">';
  content += '<tr><th>参数</th><th>右眼</th><th>左眼</th></tr>';
  content += `<tr><td>瞳高</td><td>${row.odPupilHeight || '-'}</td><td>${row.osPupilHeight || '-'}</td></tr>`;
  content += `<tr><td>瞳距</td><td>${row.odPupilDistance || '-'}</td><td>${row.osPupilDistance || '-'}</td></tr>`;
  content += `<tr><td>双眼瞳距</td><td colspan="2">${row.binocularPupilDistance || '-'}</td></tr>`;
  content += `<tr><td>镜框编号</td><td colspan="2">${row.frameNumber || '-'}</td></tr>`;
  content += `<tr><td>镜框类型</td><td colspan="2">${row.frameType || '-'}</td></tr>`;
  content += `<tr><td>眼位(远)</td><td colspan="2">${row.eyePositionFar || '-'}</td></tr>`;
  content += `<tr><td>眼位(近)</td><td colspan="2">${row.eyePositionNear || '-'}</td></tr>`;
  content += '</table>';

  // 邮寄信息
  content += '<h3>邮寄信息</h3>';
  content += '<table class="details-table">';
  content += `<tr><td>收件人</td><td>${row.addressee || '-'}</td></tr>`;
  content += `<tr><td>联系电话</td><td>${row.phone || '-'}</td></tr>`;
  content += `<tr><td>物流编号</td><td>${row.trackingNumber || '-'}</td></tr>`;
  content += `<tr><td>邮寄日期</td><td>${row.deliveryDate || '-'}</td></tr>`;
  content += `<tr><td>邮寄地址</td><td>${row.shippingAddress || '-'}</td></tr>`;
  content += `<tr><td>备注</td><td>${row.remarks || '-'}</td></tr>`;
  content += '</table>';

  content += '</div>';

  // 添加详情样式
  addDetailStyle(content);
};

// 显示批量订单详情
const showBulkOrderDetails = (row) => {
  let content = '<div class="order-details">';
  content += '<h3>订单基本信息</h3>';
  content += '<table class="details-table">';
  content += `<tr><td>订单类型</td><td>${row.orderType || '-'}</td></tr>`;
  content += `<tr><td>订单日期</td><td>${row.orderDate || '-'}</td></tr>`;
  content += `<tr><td>验光师</td><td>${row.optometrist || '-'}</td></tr>`;
  content += `<tr><td>地区</td><td>${row.region || '-'}</td></tr>`;
  content += `<tr><td>订单型号</td><td>${row.lensModel || '-'}</td></tr>`;
  content += `<tr><td>验配单位</td><td>${row.company || '-'}</td></tr>`;
  content += `<tr><td>采购单位</td><td>${row.purchasingUnits || '-'}</td></tr>`;
  content += `<tr><td>数量</td><td>${row.quantity || '0'}</td></tr>`;
  content += `<tr><td>创建时间</td><td>${row.createdAt || '-'}</td></tr>`;
  content += `<tr><td>更新时间</td><td>${row.updatedAt || '-'}</td></tr>`;
  content += '</table>';

  // 邮寄信息
  content += '<h3>邮寄信息</h3>';
  content += '<table class="details-table">';
  content += `<tr><td>收件人</td><td>${row.addressee || '-'}</td></tr>`;
  content += `<tr><td>联系电话</td><td>${row.phone || '-'}</td></tr>`;
  content += `<tr><td>物流编号</td><td>${row.trackingNumber || '-'}</td></tr>`;
  content += `<tr><td>邮寄日期</td><td>${row.deliveryDate || '-'}</td></tr>`;
  content += `<tr><td>邮寄地址</td><td>${row.shippingAddress || '-'}</td></tr>`;
  content += `<tr><td>备注</td><td>${row.remarks || '-'}</td></tr>`;
  content += '</table>';

  content += '</div>';

  // 添加详情样式
  addDetailStyle(content);
};

// 通用函数：添加详情样式并显示弹窗
const addDetailStyle = (content) => {
  // 添加CSS样式
  content += `<style>
    .el-message-box__container{
      display: block;
    }
    .order-details {
      font-size: 14px;
      padding: 0;
    }
    .order-details h3 {
      margin: 15px 0 8px;
      padding-bottom: 5px;
      border-bottom: 1px solid #EBEEF5;
      color: #409EFF;
      font-size: 16px;
    }
    .details-table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 15px;
    }
    .details-table td, .details-table th {
      padding: 8px;
      border: 1px solid #EBEEF5;
      text-align: left;
    }
    .details-table th {
      background-color: #f5f7fa;
      color: #606266;
    }
    .el-message-box.details-dialog {
       width: 50% !important;
       max-width: 700px !important;
    }
    .el-message-box.details-dialog .el-message-box__content {
       max-height: 70vh;
       overflow-y: auto;
    }

    @media screen and (max-width: 768px) {
      .order-details {
        font-size: 13px;
      }
      .details-table td, .details-table th {
        padding: 5px;
      }
    }
    @media screen and (max-width: 480px) {

      .el-message-box.details-dialog {
       width: 80% !important;
      }
    }
  </style>`;
  
  // 弹出详情对话框
  ElMessageBox.alert(content, '订单详情', {
    dangerouslyUseHTMLString: true,
    customClass: 'details-dialog',
    closeOnClickModal: true,
    distinguishCancelAndClose: true, // 区分取消和关闭操作
  }).catch(() => {
    // 静默处理取消或关闭操作
    console.log('对话框已关闭');
  });
};

// 通用订单详情显示函数，根据订单类型调用对应的处理函数
const showOrderDetails = (row, orderType) => {
  if (orderType === 'regular') {
    showRegularOrderDetails(row);
  } else if (orderType === 'fuxiangsan') {
    showFuxiangsanOrderDetails(row);
  } else if (orderType === 'bulk') {
    showBulkOrderDetails(row);
  } else {
    console.error('未知订单类型');
  }
};

// 导出函数供外部使用
defineExpose({
  showOrderDetails,
  showRegularOrderDetails,
  showFuxiangsanOrderDetails,
  showBulkOrderDetails
});
</script>

<style scoped>
/* 组件内样式可以根据需要添加 */
</style>
